import NotesEncoder from '@/helpers/NotesEncoder'
import questionData from 'questionData'
import Vue from 'vue'

export const state = {
  currentQuestion: '',
  answers: {},
  skippedQuestions: []
}

export const getters = {
  getCurrentAnswer: (state) => {
    return state.answers[state.currentQuestion] || {}
  },
  getAnswerById: (state) => (id) => {
    return state.answers[id]
  },
  answers: state => state.answers,
  progress: (state, getters) => {
    const currentQuestionIndex = getters.getQuestions.findIndex(question => question.questionId === state.currentQuestion)
    return (currentQuestionIndex + 1) / (getters.getQuestions.length + 1)
  },

  getQuestions: (state, getters) => {
    return questionData.filter(question => {
      if (question.visibility.answer) {
        const answer = getters.getAnswerById(question.visibility.answer.id)

        if (!answer) return true

        if (question.visibility.answer.type === 'include') {
          return answer.result === question.visibility.answer.value
        } else if (question.visibility.answer.type === 'exclude') {
          return answer.result !== question.visibility.answer.value
        }
      }

      return true
    })
  },
  leadNotes: (state, getters, rootState) => {
    if (!getters.hasLastAnswer) return ''
    return NotesEncoder.encode(state, rootState)
  },
  hasLastAnswer: (state, getters) => {
    const questions = getters.getQuestions
    const lastQuestion = questions[questions.length - 1]

    return Boolean(state.answers[lastQuestion.questionId])
  }
}

export const actions = {
  set_skipped_question: ({ commit }, payload) => {
    commit('SET_SKIPPED_QUESTIONS', payload)
  }
}

export const mutations = {
  SET_CURRENT_QUESTION: (state, value) => {
    state.currentQuestion = value
  },
  SET_ANSWER: (state, { questionId, answer }) => {
    Vue.set(state.answers, questionId, answer)
  },
  SET_SKIPPED_QUESTIONS: (state, payload) => {
    if (payload.addItem) {
      state.skippedQuestions.push(payload.questionId)
    } else {
      // remove array item for current q as next pressed not skip
      const filteredSkippedQuestions = state.skippedQuestions.filter(q => q !== payload.questionId)
      state.skippedQuestions = filteredSkippedQuestions
    }
  }
}
